export default __webpack_public_path__ + "static/media/Rewards.fc1afc26.svg";